module.exports = __webpack_public_path__ + "img/social-media-color-blocks-honda.a58aa09e.png";